import { NgModule } from "@angular/core";
import { MenuModule } from "../menu/menu.module";
import { SharedImportsModule } from "../shared/shared-imports.module";
import { TableControlsComponent } from "../shared/table-controls/table-controls.component";
import { ErtFiredepartmentBcTurnoverComponent } from "./ert-firedepartment-bc-turnover.component";
import { ERTFiredepartmentBcTurnoverCreateComponent } from "./ert-firedepartment-bc-turnover-create.component";
import { ERTFiredepartmentBcTurnoverEditComponent } from "./ert-firedepartment-bc-turnover-edit.component";
import { CaryoverCommentsCreateComponent } from "./carryover-comments/carryover-comments-create.component";
import { CaryoverCommentsUpdateComponent } from "./carryover-comments/carryover-comments-update.component";
import { CaryoverCommentsEditComponent } from "./carryover-comments/carryover-comments-edit.component";
const componentList = [
  ErtFiredepartmentBcTurnoverComponent,
  ERTFiredepartmentBcTurnoverCreateComponent,
  ERTFiredepartmentBcTurnoverEditComponent,
  CaryoverCommentsCreateComponent,
  CaryoverCommentsEditComponent,
  CaryoverCommentsUpdateComponent,
];

@NgModule({
  imports: [MenuModule, SharedImportsModule, TableControlsComponent],
  declarations: [componentList],
})
export class ERTFiredepartmentBcTurnoverModule {}
